import { action } from '@reatom/framework'

import { Array, Iterable, pipe, Result } from '@blade/std-lib'
import { Network } from '@root/entities/network/model'
import { type WalletId } from '@root/entities/wallet'
import { ApiError, apiRequest } from '@root/shared/api'
import { tradeApiClientAtom } from '@root/shared/api/trade-api-client-atom'

import { Summary } from '../model'

export const fetchUserSummaryRequestAction = action(
  async (
    ctx,
    {
      network,
      walletIds,
    }: { network: Network.Network; walletIds: Array<WalletId> },
  ) => {
    const { tradeApiClient } = ctx.get(tradeApiClientAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userSummaryCreate, [
        {
          network: Network.toDto(network),
          walletIds: walletIds,
        },
      ]),
    )

    const mappedResult = pipe(
      result,
      Result.map((it) =>
        pipe(
          it,
          Iterable.map(Summary.fromDto),
          Iterable.toArray,
          Array.sort(Summary.cmpByTimestamp),
        ),
      ),
      Result.mapError(ApiError.fallbackToUnknown),
    )

    return mappedResult
  },
  'fetchUserSummaryRequestAction',
)
